<div class="container-fluid lw-outbox-container padding-0">
    <!-- Tab Buttons -->
    <div class="">
        <div class="ltms-tabs lato-bold-dark">
            <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'responded' }"
                (click)="toggleTab('responded')">Responded</div>
            <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'not_responded' }"
                (click)="toggleTab('not_responded')">Not Responded</div>
        </div>
    </div>
    <!-- filters -->
    <div class="ltms-description" *ngIf="activeTab === 'responded'">
        Review all customer outreach attempts from this project that have received a response, along with contact
        details and attempt history.
    </div>

    <div class="ltms-nr-description" *ngIf="activeTab === 'not_responded'">
        <span class="ltms-description">Review all customer outreach attempts from this project that have not yet received a response, including contact details and attempt status. </span> <br>
        <span class="ltms-description ltms-description-darker" *ngIf="is_cohort_based_search_enabled && defaultSelectedField.field_id.startsWith('tag_')">
            Search by {{ defaultSelectedField.field_text }} is available for the last
            {{ brandDetails?.outbox_configurations?.max_cohort_search_days ?? 30 }}
            days only. Enter the complete {{ defaultSelectedField.field_text }} and press Enter to search.
        </span>
    </div>

    <div class="litmus-feed-list-controls">
        <div class="litmus-left-controls">

            <!-- left filters -->
            <div class="litmus-feed-controls">
                <button type="button" *ngIf="isProjectManager" class="request-btn" (click)="openNewRequest()">
                    <!-- <button type="button" class="request-btn" > -->
                    <span class="request-btn-label">New Request</span>
                </button>
                <div class="litmus-feed-controls">
                    <div class="litmus-refresh-feeds">
                        <label for="refresh_feeds" (click)='refreshData()'>
                            <img src="assets/images/refresh.svg" /> Refresh
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <!-- right filters -->
        <div class="litmus-right-controls">
            <!-- search box -->
             <div *ngIf="searchBoxVisible" class="litmus-feed-filter" #ltmsOutboxsearch id="ltmsOutboxsearch">
                <div class="litmus-feed-filter-input " [class.active]="showFilterFields">
                    <img class="search-icon" src="assets/images/magnify.svg">
                    <input *ngIf="this.is_cohort_based_search_enabled && this.defaultSelectedField.field_id.startsWith('tag_'); else normalInput" class="litmus-feed-input-field"
                        [placeholder]="'Search by ' + defaultSelectedField.field_text" type="text"
                        [(ngModel)]="searchText" (keyup.enter)="searchCohortBasedRequests($event)"
                        autocomplete="nope" [disabled]="isCohertFilterApplied" />
                    <ng-template #normalInput>
                        <input class="litmus-feed-input-field" [placeholder]="'Search by ' + defaultSelectedField.field_text" type="text"
                            (keyup)="searchUserByType($event)" [(ngModel)]="searchText" (click)="toggleSearchList()" autocomplete="nope" />
                    </ng-template>
                    <button [class.hidden]="!isTextEntered" (click)="clearSearchBox()">
                        <img class="clear-img" src="assets/images/close.svg">
                    </button>
                    <button (click)="toggleFilterFieldList()" class="field-dropdown-button">
                        <img src="assets/images/menu-down-dark.svg" />
                    </button>
                </div>
                <ul id="litmus-search-list" *ngIf="showSearchList" #searchList class="litmus-feed-filter-list">
                    <li *ngFor="let item of searchResult.options" [class.disabled-message]="item.id == ''"
                        (click)="searchListSelectedvalue(item)" [innerHTML]="item.text">
                    </li>

                </ul>
                <ul id="litmus-search-selector" *ngIf="showFilterFields" class="litmus-feed-filter-list">
                    <li *ngFor="let item of searchAvailableOnList" (click)="changeFilterField(item)"
                        [class.active]=" item.field_id == defaultSelectedField.field_id">
                        {{item.field_text}}
                    </li>
                </ul>
            </div>
            <!-- pagination -->
            <div class="litmus-outbox-paging">
                <button [disabled]="!pagingButtons.isPrevious || loading" (click)="paginateOutbox('previous')">
                    <img src="assets/images/chevron-left.svg" />
                </button>
                <span [class.disabled]="pagingDetails.total <= 0">
                    {{pagingDetails.start}} - {{pagingDetails.end}}
                </span>
                <button [disabled]="!pagingButtons.isNext || loading" (click)="paginateOutbox('next')">
                    <img src="assets/images/chevron-right.svg" />
                </button>
            </div>
        </div>
    </div>
    <!-- data table -->
    <!-- <div *ngIf="isDataLoaded" class="data-table-container">
        <ng-container
            *ngIf="prepared_responded_list.length > 0 || prepared_non_responded_list.length > 0; else noDataTemplate">
            <app-ltms-data-table-v2 [columns]="requestsJourneyHeader" [data]="prepared_responded_list"
                [errorCode]="'404'" [configs]="tableConfig" (onRowSelect)="showChannelStatus($event)">
            </app-ltms-data-table-v2>
        </ng-container>
        <ng-template #noDataTemplate>
            <div class="no-data-container">
                <p class="no-data-message" *ngIf="!params?.user_id">No data available for the current date range. Try
                    changing the date range.</p>
                <p class="no-data-message" *ngIf="params?.user_id && activeTab == 'responded'">No data for the selected
                    date range in Responded. Try adjusting the range or switch to Not Responded.</p>
                <p class="no-data-message" *ngIf="params?.user_id && activeTab == 'not_responded'">No data for the
                    selected date range in Not Responded. Try adjusting the range or switch to Responded.</p>
            </div>
        </ng-template>
    </div> -->
    <div #dataTableContainer *ngIf="isDataLoaded" class="data-table-container ellipsis">
        <ng-container
          *ngIf="prepared_responded_list.length > 0 || prepared_non_responded_list.length > 0; else noDataTemplate">
          <app-ltms-data-table-v2
            [columns]="requestsJourneyHeader"
            [data]="prepared_responded_list"
            [errorCode]="'404'"
            [configs]="tableConfig"
            (onRowSelect)="showChannelStatus($event)"
            (onSelect)="onTableAction($event)">
          </app-ltms-data-table-v2>
        </ng-container>
      
        <ng-template #noDataTemplate>
          <div class="no-data-container">
            <p class="no-data-message" *ngIf="!params?.user_id">
              No data available for the current date range. Try changing the date range.
            </p>
            <p class="no-data-message" *ngIf="params?.user_id && activeTab == 'responded'">
              No data for the selected date range in Responded. Try adjusting the range or switch to Not Responded.
            </p>
            <p class="no-data-message" *ngIf="params?.user_id && activeTab == 'not_responded'">
              No data for the selected date range in Not Responded. Try adjusting the range or switch to Responded.
            </p>
          </div>
        </ng-template>
      </div>
      
      
    <div class="outbox-loader" *ngIf="!isDataLoaded">
        <app-ltms-loader></app-ltms-loader>
    </div>
</div>

<!-- On-demand Send / Custom / Cancel choice -->
<div class="on-demand-choice-modal" *ngIf="showOnDemandChoiceModal" role="dialog" aria-modal="true">
  <div class="on-demand-choice-dialog">
    <div class="on-demand-choice-body">
      <div class="on-demand-choice-title">Alert!</div>
      <p class="on-demand-choice-text">
        This will immediately trigger an on-demand request to the customer. Proceed only if you are absolutely certain.
        Triggering this action may cause critical and irreversible issues. Do not proceed unless you are fully aware of
        the consequences. Are you sure you want to continue?
      </p>
      <div class="on-demand-choice-actions">
        <button type="button" class="btn-choice btn-choice-cancel" (click)="onOnDemandChoiceCancel()">Cancel</button>
        <button type="button" class="btn-choice btn-choice-custom" (click)="onOnDemandChoiceCustom()">Custom</button>
        <button type="button" class="btn-choice btn-choice-send" (click)="onOnDemandChoiceSend()">Send</button>
      </div>
    </div>
  </div>
</div>

<app-outbox-detail-panel [OutboxDetailsVisible]="OutboxDetailsVisible" [selectedChannelDetail]="selectedChannelDetail"
    [isRefreshing]="isDetailPanelRefreshing" [isNotRespondedTab]="activeTab == 'not_responded'"
    (close)="closeOutboxDetailPanel()"
    (refresh)="refreshOutboxDetailPanel()"></app-outbox-detail-panel>

<app-outbox-channel-selection-panel
    [visible]="channelSelectionPanelVisible"
    [isLoading]="isChannelConfigLoading"
    [isSending]="isChannelPanelSending"
    [onDemandConfigurations]="onDemandConfigurations"
    [requestTrials]="selectedRequestForChannelSend?.trials || []"
    [request]="selectedRequestForChannelSend"
    [tagSearchContext]="channelPanelTagContext"
    [requestDeadlineAt]="channelPanelRequestDeadlineAt"
    [requestDeadlineAbsolute]="channelPanelRequestDeadlineAbsolute"
    (close)="closeChannelSelectionPanel()"
    (send)="onChannelSelectionSend($event)"
    (viewDetails)="viewRequestDetailsFromChannelPanel()">
</app-outbox-channel-selection-panel>

<app-outbox-request-creation [newReqestPanelVisible]="newReqestPanelVisible"
    (close)="closeNewRequestPanel()"></app-outbox-request-creation>